import React, { useState, useEffect } from "react";
import { Container, Col } from "react-bootstrap";
import "./benefits.css";

const Benefits = () => {
  const benefitSections = [
    {
      title: "Improved Employee Engagement",
      description:
        "By providing managers with personalized insights, Wolbee helps boost employee engagement, ensuring that team members feel recognized, valued, and motivated to contribute.",
    },
    {
      title: "Enhanced Communication and Team Dynamics",
      description:
        "Wolbee helps managers understand team collaboration patterns, improving communication and teamwork. This leads to stronger relationships and a more harmonious work environment.",
    },
    {
      title: "Informed Decision-Making",
      description:
        "With daily, actionable insights, managers are equipped with the information they need to make informed decisions that support employee growth, satisfaction, and overall team success.",
    },
    {
      title: "Fostering a Supportive Work Culture",
      description:
        "Wolbee’s recommendations enable managers to take meaningful actions that support their employees’ needs, ultimately creating a workplace culture where employees feel empowered, valued, and heard.",
    },
    {
      title: "Streamlined Management Processes",
      description:
        "Wolbee consolidates key employee insights into an easy-to-use platform, saving time and effort for managers while providing a clearer understanding of their team’s dynamics and needs.",
    },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % benefitSections.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [benefitSections.length]);

  const previousIndex =
    (currentIndex - 1 + benefitSections.length) % benefitSections.length;
  const nextIndex = (currentIndex + 1) % benefitSections.length;

  const handleBoxClick = (index) => {
    setCurrentIndex(index);
  };

  return (
    <React.Fragment>
      <section className="benefits-section" id="benefits">
        <Container>
          <Col lg={12}>
            <div className="sec-hd mb-4">
              <span className="heading"></span>
              <h2 className="sec-title">Benefits Overview</h2>
              <span className="heading"></span>
            </div>
          </Col>
          <br />
          <br />
          <div className="gallery">
            <div
              className={`small-box ${
                currentIndex === previousIndex ? "active" : ""
              }`}
              onClick={() => handleBoxClick(previousIndex)}
            >
              <h5>{benefitSections[previousIndex].title}</h5>
              <p className="small-description benefits-description">
                {benefitSections[previousIndex].description}
              </p>
            </div>
            <div className="large-box">
              <h5>{benefitSections[currentIndex].title}</h5>
              <p className=" benefits-description">{benefitSections[currentIndex].description}</p>
            </div>
            <div
              className={`small-box ${
                currentIndex === nextIndex ? "active" : ""
              }`}
              onClick={() => handleBoxClick(nextIndex)}
            >
              <h5>{benefitSections[nextIndex].title}</h5>
              <p className="small-description  benefits-description">
                {benefitSections[nextIndex].description}
              </p>
            </div>
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Benefits;
